import Qs from "qs";
import { Builder } from "logic/rest/FetchProvider";
import * as URLUtils from "util/URLUtils";
const headersFromOptions = (options) => {
  var _a;
  if (options == null ? void 0 : options.requestShouldExtendSession) {
    return { "X-Graylog-No-Session-Extension": !((_a = options == null ? void 0 : options.requestShouldExtendSession) != null ? _a : true) };
  }
  return {};
};
const request = (method, path, body, query, headers, options = {}) => {
  const pathWithQueryParameters = Object.entries(query).length > 0 ? `${path}?${Qs.stringify(query, { indices: false })}` : path;
  const optionHeaders = headersFromOptions(options);
  const _headers = {
    ...headers,
    ...optionHeaders
  };
  return new Builder(method, URLUtils.qualifyUrl(pathWithQueryParameters)).json(body).setHeaders(_headers).build();
};
export default request;
